import CustomFieldParentType from "enums/CustomFieldParentType";
import CustomFieldStatus from "enums/CustomFieldStatus";
import CustomFieldType from "enums/CustomFieldType";

// Full shape used by the editor formik. Also describes a setting record as
// returned from the API (the renderer narrows query results to this type).
export type FormikCustomField = {
  id?: string;
  parentTypes: CustomFieldParentType[];
  label: string;
  type: CustomFieldType | "";
  allowMultipleEntries: boolean;
  isRequired: boolean;
  options?: string[];
  status: CustomFieldStatus;
  order: number;
};

// Looser shape used at the API/edge boundary and for the live-render preview.
// `allowMultipleEntries` and `isRequired` are optional because the renderer
// receives partial nodes for preview-only flows.
export type SimplifiedCustomField = {
  id?: string;
  label: string;
  type: CustomFieldType | "";
  allowMultipleEntries?: boolean;
  isRequired?: boolean;
  options?: string[];
  status: CustomFieldStatus;
};

export type CustomFieldValue = {
  id: string;
  label: string;
  value: string;
};

export type CustomFieldsRecord = Record<string, string[]>;

export const CustomFieldTypeDisplay = {
  [CustomFieldType.CHECKBOX]: "Checkbox",
  [CustomFieldType.LIST]: "List",
  [CustomFieldType.RADIO]: "Radio",
  [CustomFieldType.TEXT]: "Text",
  [CustomFieldType.ALLOCATION]: "Allocation List",
};

export const CustomFieldParentTypeDisplay = {
  [CustomFieldParentType.USER]: "Users",
  [CustomFieldParentType.CARD]: "Cards",
  [CustomFieldParentType.TRANSACTION]: "Transactions",
  [CustomFieldParentType.INVOICE]: "Invoices",
  [CustomFieldParentType.PAYMENT]: "Payments",
  [CustomFieldParentType.CONTACT]: "Contacts",
  [CustomFieldParentType.REIMBURSEMENT]: "Reimbursements",
};
